// eslint-disable-next-line no-undef
if (!customElements.get('sd-rebrand-sticky-cta')) {
  // eslint-disable-next-line no-undef
  class SdRebrandStickyCta extends HTMLElement {
    constructor () {
      super()
      this.triggerSelector = this.dataset.triggerSelector || '.sd-rebrand-buy-button'
      this.priceEl = this.querySelector('[data-sticky-price]')
      this.variantSelect = this.querySelector('[data-sticky-variant-select]')

      // Parse variant data
      const variantJson = this.querySelector('[data-sticky-variants]')
      this.variants = variantJson ? JSON.parse(variantJson.textContent) : []
    }

    connectedCallback () {
      this.onScroll = this.onScroll.bind(this)
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()

      this.onResize = this.updatePosition.bind(this)
      window.addEventListener('resize', this.onResize)
      this.updatePosition()

      // Handle dropdown change within the sticky bar
      if (this.variantSelect) {
        this.onSelectChange = this.onSelectChange.bind(this)
        this.variantSelect.addEventListener('change', this.onSelectChange)
      }

      this.setupPriceSync()
      this.syncInitialVariant()
    }

    syncInitialVariant () {
      // Sync sticky bar's dropdown + price + buy button with the variant picker's default
      const variantJson = document.querySelector('variant-selects [data-selected-variant]')
      if (!variantJson) return
      try {
        const variant = JSON.parse(variantJson.textContent)
        if (!variant || !variant.id) return

        // Update dropdown selection
        if (this.variantSelect) {
          this.variantSelect.value = variant.id
        }

        // Update price
        if (this.priceEl) {
          const cents = variant.price % 100
          const dollars = Math.floor(variant.price / 100)
          this.priceEl.textContent = cents === 0
            ? '$' + dollars.toLocaleString('en-US')
            : '$' + dollars.toLocaleString('en-US') + '.' + String(cents).padStart(2, '0')
        }

        // Update buy button's hidden variant input
        const buyButton = this.querySelector('sd-rebrand-buy-button')
        if (buyButton) {
          const input = buyButton.querySelector('input[name="id"]')
          if (input) input.value = variant.id
        }
      } catch (e) { /* ignore parse errors */ }
    }

    disconnectedCallback () {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onResize)
      if (this.variantSelect) {
        this.variantSelect.removeEventListener('change', this.onSelectChange)
      }
      if (this.variantChangeUnsub) this.variantChangeUnsub()
    }

    onScroll () {
      const trigger = document.querySelector(this.triggerSelector)
      if (!trigger) return
      const rect = trigger.getBoundingClientRect()
      const scrolledPastViewport = window.scrollY >= window.innerHeight
      if (rect.bottom <= 0 && scrolledPastViewport) {
        this.classList.add('is-visible')
      } else {
        this.classList.remove('is-visible')
      }
    }

    updatePosition () {
      if (window.innerWidth >= 750) {
        const header = document.querySelector('sticky-header') ||
          document.querySelector('.sleepdoctor-header-offcanvas .header-wrapper') ||
          document.querySelector('.header-wrapper')
        const announcement = document.querySelector('.announcement-bar-section')
        let offset = 0
        if (header) offset += header.offsetHeight
        if (announcement) offset += announcement.offsetHeight
        this.style.top = offset + 'px'
        this.style.bottom = 'auto'
      } else {
        this.style.top = ''
        this.style.bottom = '0'
      }
    }

    onSelectChange () {
      const selectedId = parseInt(this.variantSelect.value, 10)
      const variant = this.variants.find(function (v) { return v.id === selectedId })
      if (!variant) return

      // Update price
      if (this.priceEl) {
        const cents = variant.price % 100
        const dollars = Math.floor(variant.price / 100)
        this.priceEl.textContent = cents === 0
          ? '$' + dollars.toLocaleString('en-US')
          : '$' + dollars.toLocaleString('en-US') + '.' + String(cents).padStart(2, '0')
      }

      // Update the rebrand buy button's hidden variant input
      const buyButton = this.querySelector('sd-rebrand-buy-button')
      if (buyButton) {
        const input = buyButton.querySelector('input[name="id"]')
        if (input) input.value = variant.id
      }

      // Dispatch variantChanged event for other listeners
      document.dispatchEvent(new CustomEvent('variantChanged', {
        detail: { variantId: variant.id }
      }))

      // Sync with the main product page variant picker
      this.syncMainVariantPicker(variant)

      // Publish via pub/sub if available
      // eslint-disable-next-line no-undef
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // eslint-disable-next-line no-undef
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.dataset.section,
            variant
          }
        })
      }
    }

    syncMainVariantPicker (variant) {
      // Find the main product variant-selects and update its dropdowns
      const mainPicker = document.querySelector('variant-selects:not([data-section="' + this.dataset.section + '"])')
      if (!mainPicker) return

      // Build the option values from the variant title (e.g. "8 Sessions / Blue")
      const optionValues = []
      if (variant.option1) optionValues.push(variant.option1)
      if (variant.option2) optionValues.push(variant.option2)
      if (variant.option3) optionValues.push(variant.option3)

      // Update main picker's select elements
      const selects = mainPicker.querySelectorAll('select')
      selects.forEach(function (select, index) {
        if (optionValues[index] && select.value !== optionValues[index]) {
          select.value = optionValues[index]
          select.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })

      // Also update radio buttons if the main picker uses pills
      const fieldsets = mainPicker.querySelectorAll('fieldset')
      fieldsets.forEach(function (fieldset, index) {
        if (!optionValues[index]) return
        const radio = fieldset.querySelector('input[value="' + optionValues[index] + '"]')
        if (radio && !radio.checked) {
          radio.checked = true
          radio.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
    }

    setupPriceSync () {
      // eslint-disable-next-line no-undef
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setupPriceSync())
        }
        return
      }

      // Update price + dropdown when variant changes from the main product picker
      // eslint-disable-next-line no-undef
      this.variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event.data || !event.data.variant) return

        // Skip if this event came from our own select change
        if (event.data.sectionId === this.dataset.section) return

        const variant = event.data.variant

        // Update price
        if (this.priceEl) {
          const dollars = Math.floor(variant.price / 100)
          this.priceEl.textContent = '$' + dollars.toLocaleString('en-US')
        }

        // Sync the dropdown selection
        if (this.variantSelect) {
          this.variantSelect.value = variant.id
        }

        // Update the rebrand buy button's hidden variant input
        const buyButton = this.querySelector('sd-rebrand-buy-button')
        if (buyButton) {
          const input = buyButton.querySelector('input[name="id"]')
          if (input) input.value = variant.id
        }
      })
    }
  }

  // eslint-disable-next-line no-undef
  customElements.define('sd-rebrand-sticky-cta', SdRebrandStickyCta)
}
